import { gql } from "@apollo/client";

const FEDERATION_BY_ID = gql`
  query federation($id: Int, $publicId: String, $platform: Int) {
    federation(id: $id, publicId: $publicId, platform: $platform) {
      user {
        id
        name
        surname
        email
        phone
        instagram
      }
      platforms {
        customFee {
          id
          currency
          rangeStart
          rangeEnd
          feeType
          serviceType
          feeMode
          tournatedFee
          tournatedMinFee
          tournatedMaxFee
          partnerFee
          partnerMinFee
          partnerMaxFee
          isMonetization
          isManagerPayingServiceFee
          tournatedMinPercentageFee
          tournatedMaxPercentageFee
          partnerMinPercentageFee
          partnerMaxPercentageFee
        }
        platform {
          id
          title
          sports {
            sport {
              id
              title
            }
          }
          customFee {
            id
            currency
            rangeStart
            rangeEnd
            feeType
            serviceType
            tournatedFee
            tournatedMinFee
            tournatedMaxFee
            partnerFee
            partnerMinFee
            partnerMaxFee
            isMonetization
            isManagerPayingServiceFee
            tournatedMinPercentageFee
            tournatedMaxPercentageFee
            partnerMinPercentageFee
            partnerMaxPercentageFee
          }
          isTournatedFeeVatEnable
          tournatedFeeVat
        }
      }
      country
      organizationName
      organizationAbbreviation
      organizationType
      logo
      about
      contactEmail
      contactPhone
      status
      website
      id
    }
  }
`;

export default FEDERATION_BY_ID;
